module.exports = __webpack_public_path__ + "al.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/al.svg
// module id = 668
// module chunks = 0